module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100"
  }, [(_vm.dataReady) ? _c('section', {
    staticClass: "section-liste-salaries noselect"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "left"
  }, [(_vm.canCreateSalarie) ? _c('button', {
    staticClass: "inp-button green mr-2",
    attrs: {
      "type": "button",
      "title": "Ajouter un salarié"
    },
    on: {
      "click": function($event) {
        _vm.openSalarie(0, 'Nouveau salarié')
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-user-plus"
  }), _vm._v(" "), _c('span', {
    staticClass: "text ml-2 d-none d-xl-inline"
  }, [_vm._v("Ajouter un salarié")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inp-input-mini icon mr-2",
    attrs: {
      "data-testid": "filtreTypeContrat-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtreTypeContrat),
      expression: "filtreTypeContrat"
    }],
    staticClass: "input",
    attrs: {
      "data-testid": "filtreTypeContrat-select"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtreTypeContrat = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.doFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "EnCours"
    }
  }, [_vm._v("Contrats en cours")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ActifExercice"
    }
  }, [_vm._v("Contrats actifs de l'exercice")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Tous"
    }
  }, [_vm._v("Tous les contrats")])]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })]), _vm._v(" "), (!_vm.modeTuilles && _vm.salariesFiltred.length > 0) ? _c('button', {
    staticClass: "inp-button orange mr-2",
    attrs: {
      "type": "button",
      "title": "Filtrer"
    },
    on: {
      "click": function($event) {
        _vm.openModalFilterListeSalaries()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-filter"
  }), _vm._v(" "), _c('span', {
    staticClass: "text ml-2 d-none d-xl-inline"
  }, [_vm._v("Filtrer")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "inp-button blue mr-2",
    attrs: {
      "type": "button",
      "title": "Télécharger la liste des salariés"
    },
    on: {
      "click": function($event) {
        _vm.telecharger()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-download fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "text ml-2 d-none d-xl-inline"
  }, [_vm._v("Télécharger")])]), _vm._v(" "), _c('button', {
    staticClass: "inp-button turquoise mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.exporter()
      }
    }
  }, [_c('span', {
    staticClass: "icon far fa-file-excel mr-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Exporter")])]), _vm._v(" "), (_vm.isModDemarrage) ? _c('button', {
    staticClass: "inp-button green mr-2",
    attrs: {
      "type": "button",
      "title": "Ajouter un fichier DSN"
    },
    on: {
      "click": function($event) {
        _vm.addDsn()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-file-medical"
  }), _vm._v(" "), _c('span', {
    staticClass: "text ml-2 d-none d-xl-inline"
  }, [_vm._v("Ajouter un fichier DSN")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "inp-radio mr-2"
  }, [_c('span', {
    staticClass: "text title mr-2 d-none d-lg-inline d-xl-inline"
  }, [_vm._v("Type d'Affichage")]), _vm._v(" "), _c('div', {
    staticClass: "area",
    staticStyle: {
      "margin-left": "auto"
    }
  }, [_c('div', {
    staticClass: "radio"
  }, [(!_vm.modeTuilles) ? _c('input', {
    attrs: {
      "type": "radio",
      "name": "radio1",
      "id": "oui",
      "value": "oui",
      "checked": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": "oui",
      "title": "Afficher en liste"
    },
    on: {
      "click": function($event) {
        _vm.changeModeTuile(false)
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-th-list"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [(_vm.modeTuilles) ? _c('input', {
    attrs: {
      "type": "radio",
      "name": "radio1",
      "id": "non",
      "value": "non",
      "checked": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": "non",
      "title": "Afficher en grille"
    },
    on: {
      "click": function($event) {
        _vm.changeModeTuile(true)
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-th"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "inp-input-mini icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterName),
      expression: "filterName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "placeholder": "Rechercher",
      "data-testid": "salaries-search-input"
    },
    domProps: {
      "value": (_vm.filterName)
    },
    on: {
      "keyup": function($event) {
        _vm.doFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filterName.length == 0) ? _c('span', {
    staticClass: "icon-inner fas fa-search"
  }) : _c('span', {
    staticClass: "icon-inner fas fa-times cls",
    on: {
      "click": function($event) {
        _vm.filterName = '';
        _vm.doFilter()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(!_vm.modeTuilles && _vm.salariesFiltred.length > 0) ? _c('div', {
    staticClass: "table-mode"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "inp-table noselect d-inline-block"
  }, [_c('div', {
    staticClass: "thead"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th cln-salarie",
    attrs: {
      "title": "N° Salarié"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('Numero')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("N°")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('Numero', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('Numero', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-crpcen",
    attrs: {
      "title": "N° Contrat"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('NumeroContrat')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Contrat")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('NumeroContrat', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('NumeroContrat', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-civilite",
    attrs: {
      "title": "CIVILITÉ"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('Civilite')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("CIVILITÉ")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('Civilite', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('Civilite', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-nom",
    style: (_vm.getSizeColName()),
    attrs: {
      "title": "NOM / PRÉNOM",
      "data-testid": "nom-prenom-field"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('FullName')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("NOM / PRÉNOM")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('FullName', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('FullName', true)
  })])]), _vm._v(" "), (_vm.NomNaissanceVisible) ? _c('div', {
    staticClass: "th cln-naissance",
    attrs: {
      "title": "NOM NAISSANCE"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('NomNaissance')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("NOM NAISSANCE")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('NomNaissance', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('NomNaissance', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.DateNaissanceVisible) ? _c('div', {
    staticClass: "th cln-date-naissance",
    attrs: {
      "title": "DATE DE NAISSANCE"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('DateNaissance')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("DATE DE NAISSANCE")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('DateNaissance', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('DateNaissance', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.QualificationVisible) ? _c('div', {
    staticClass: "th cln-qualification",
    attrs: {
      "title": "QUALIFICATION"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('Qualification')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("QUALIFICATION")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('Qualification', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('Qualification', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.LibelleEmploiVisible) ? _c('div', {
    staticClass: "th cln-emploi",
    attrs: {
      "title": "LIBELLÉ EMPLOI"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('LibelleEmploi')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("LIBELLÉ EMPLOI")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('LibelleEmploi', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('LibelleEmploi', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.DateEntreeVisible) ? _c('div', {
    staticClass: "th cln-entree",
    attrs: {
      "title": "DATE ENTRÉE"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('DateEntree')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("DATE ENTRÉE")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('DateEntree', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('DateEntree', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.DateDebutContratVisible) ? _c('div', {
    staticClass: "th cln-debut",
    attrs: {
      "title": "DÉBUT CONTRAT"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('DateDebutContrat')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("DÉBUT CONTRAT")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('DateDebutContrat', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('DateDebutContrat', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.DateDepartVisible) ? _c('div', {
    staticClass: "th cln-sortie",
    attrs: {
      "title": "DATE SORTIE"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('DateDepart')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("DATE SORTIE")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('DateDepart', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('DateDepart', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.DateFinPeriodeEssaiVisible) ? _c('div', {
    staticClass: "th cln-essai",
    attrs: {
      "title": "FIN DE PÉRIODE D'ESSAI"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('DateFinPeriodeEssai')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("FIN PÉRIODE ESSAI")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('DateFinPeriodeEssai', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('DateFinPeriodeEssai', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.DateFinContratVisible) ? _c('div', {
    staticClass: "th cln-fin",
    attrs: {
      "title": "FIN CONTRAT"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('DateFinContrat')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("FIN CONTRAT")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('DateFinContrat', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('DateFinContrat', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.DateFinPrevisionnelleCddVisible) ? _c('div', {
    staticClass: "th cln-previsionnelle",
    attrs: {
      "title": "FIN PRÉVISIONNELLE CDD"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('DateFinPrevisionnelleCdd')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("FIN PRÉVISIONNELLE")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('DateFinPrevisionnelleCdd', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('DateFinPrevisionnelleCdd', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.TypeContratVisible) ? _c('div', {
    staticClass: "th cln-type",
    attrs: {
      "title": "TYPE"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('TypeContrat')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("TYPE")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('TypeContrat', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('TypeContrat', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.RegimeVisible) ? _c('div', {
    staticClass: "th cln-regime",
    attrs: {
      "title": "RÉGIME"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('Regime')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("RÉGIME")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('Regime', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('Regime', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.BulletinParMailVisible) ? _c('div', {
    staticClass: "th cln-bulletin",
    attrs: {
      "title": "BULLETIN PAR MAIL"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('BulletinParMail')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("BULLETIN PAR MAIL")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('BulletinParMail', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('BulletinParMail', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.NatureContratVisible) ? _c('div', {
    staticClass: "th cln-nature",
    attrs: {
      "title": "NATURE CONTRAT"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('NatureContrat')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("NATURE CONTRAT")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('NatureContrat', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('NatureContrat', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.ServiceVisible) ? _c('div', {
    staticClass: "th cln-service",
    attrs: {
      "title": "SERVICE"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('Service')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("SERVICE")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('Service', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('Service', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.RemunerationVisible) ? _c('div', {
    staticClass: "th cln-remuneration",
    attrs: {
      "title": "RÉMUNÉRATION"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('Remuneration')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("RÉMUNÉRATION")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('Remuneration', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('Remuneration', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.CongesVisible) ? _c('div', {
    staticClass: "th cln-conges",
    attrs: {
      "title": "CONGÉS"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('Conges')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("CONGÉS")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('Conges', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('Conges', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.ConventionCollectiveVisible) ? _c('div', {
    staticClass: "th cln-convention",
    attrs: {
      "title": "CONVENTION COLLECTIVE"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('ConventionCollective')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("CONVENTION COLLECTIVE")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('ConventionCollective', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('ConventionCollective', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.TempsTravailVisible) ? _c('div', {
    staticClass: "th cln-temps",
    attrs: {
      "title": "TEMPS DE TRAVAIL"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('TempsTravail')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("TEMPS DE TRAVAIL")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('TempsTravail', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('TempsTravail', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.MutuelleVisible) ? _c('div', {
    staticClass: "th cln-mutuelle",
    attrs: {
      "title": "MUTUELLE"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('Mutuelle')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("MUTUELLE")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('Mutuelle', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('Mutuelle', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.ModeReglementVisible) ? _c('div', {
    staticClass: "th cln-mode",
    attrs: {
      "title": "MODE DE RÈGLEMENT"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('ModeReglement')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("MODE DE RÈGLEMENT")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('ModeReglement', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('ModeReglement', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.ResponsableHierarchiqueVisible) ? _c('div', {
    staticClass: "th cln-responsable",
    attrs: {
      "title": "RESPONSABLE HIÉRARCHIQUE"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('ResponsableHierarchique')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("RESPONSABLE HIÉRARCHIQUE")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('ResponsableHierarchique', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('ResponsableHierarchique', true)
  })])]) : _vm._e(), _vm._v(" "), (_vm.DateEntreeProfessionVisible) ? _c('div', {
    staticClass: "th cln-profession",
    attrs: {
      "title": "DATE D'ANCIENNETE DANS LA PROFESSION"
    },
    on: {
      "click": function($event) {
        _vm.oderBy('DateEntreeProfession')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("DATE D'ANCIENNETE DANS LA PROFESSION")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.getClassOfOrder('DateEntreeProfession', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.getClassOfOrder('DateEntreeProfession', true)
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tbody"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "section cln-salarie"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-crpcen"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-civilite"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-nom",
    style: (_vm.getSizeColName()),
    attrs: {
      "data-testid": "cln-nom-field"
    }
  }), _vm._v(" "), (_vm.NomNaissanceVisible) ? _c('div', {
    staticClass: "section cln-naissance"
  }) : _vm._e(), _vm._v(" "), (_vm.DateNaissanceVisible) ? _c('div', {
    staticClass: "section cln-date-naissance"
  }) : _vm._e(), _vm._v(" "), (_vm.QualificationVisible) ? _c('div', {
    staticClass: "section cln-qualification"
  }) : _vm._e(), _vm._v(" "), (_vm.LibelleEmploiVisible) ? _c('div', {
    staticClass: "section cln-emploi"
  }) : _vm._e(), _vm._v(" "), (_vm.DateEntreeVisible) ? _c('div', {
    staticClass: "section cln-entree"
  }) : _vm._e(), _vm._v(" "), (_vm.DateDebutContratVisible) ? _c('div', {
    staticClass: "section cln-debut"
  }) : _vm._e(), _vm._v(" "), (_vm.DateDepartVisible) ? _c('div', {
    staticClass: "section cln-sortie"
  }) : _vm._e(), _vm._v(" "), (_vm.DateFinPeriodeEssaiVisible) ? _c('div', {
    staticClass: "section cln-essai"
  }) : _vm._e(), _vm._v(" "), (_vm.DateFinContratVisible) ? _c('div', {
    staticClass: "section cln-fin"
  }) : _vm._e(), _vm._v(" "), (_vm.DateFinPrevisionnelleCddVisible) ? _c('div', {
    staticClass: "section cln-previsionnelle"
  }) : _vm._e(), _vm._v(" "), (_vm.TypeContratVisible) ? _c('div', {
    staticClass: "section cln-type"
  }) : _vm._e(), _vm._v(" "), (_vm.RegimeVisible) ? _c('div', {
    staticClass: "section cln-regime"
  }) : _vm._e(), _vm._v(" "), (_vm.BulletinParMailVisible) ? _c('div', {
    staticClass: "section cln-bulletin"
  }) : _vm._e(), _vm._v(" "), (_vm.NatureContratVisible) ? _c('div', {
    staticClass: "section cln-nature"
  }) : _vm._e(), _vm._v(" "), (_vm.ServiceVisible) ? _c('div', {
    staticClass: "section cln-service"
  }) : _vm._e(), _vm._v(" "), (_vm.RemunerationVisible) ? _c('div', {
    staticClass: "section cln-remuneration"
  }) : _vm._e(), _vm._v(" "), (_vm.CongesVisible) ? _c('div', {
    staticClass: "section cln-conges"
  }) : _vm._e(), _vm._v(" "), (_vm.ConventionCollectiveVisible) ? _c('div', {
    staticClass: "section cln-convention"
  }) : _vm._e(), _vm._v(" "), (_vm.TempsTravailVisible) ? _c('div', {
    staticClass: "section cln-temps"
  }) : _vm._e(), _vm._v(" "), (_vm.MutuelleVisible) ? _c('div', {
    staticClass: "section cln-mutuelle"
  }) : _vm._e(), _vm._v(" "), (_vm.ModeReglementVisible) ? _c('div', {
    staticClass: "section cln-mode"
  }) : _vm._e(), _vm._v(" "), (_vm.ResponsableHierarchiqueVisible) ? _c('div', {
    staticClass: "section cln-responsable"
  }) : _vm._e(), _vm._v(" "), (_vm.DateEntreeProfessionVisible) ? _c('div', {
    staticClass: "section cln-profession"
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.salariesFiltred), function(item) {
    return _c('div', {
      staticClass: "tr",
      class: _vm.isFinContrat(item) ? 'grey-line' : '',
      attrs: {
        "data-testid": "salaries-grid-row",
        "data-contrat-termine": _vm.isFinContrat(item) ? 'true' : 'false'
      }
    }, [_c('div', {
      staticClass: "td cln-salarie text-center"
    }, [_vm._v(_vm._s(item.Numero))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-crpcen text-center",
      attrs: {
        "title": item.NumeroContrat
      }
    }, [_vm._v(_vm._s(item.NumeroContrat))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-civilite text-center"
    }, [_vm._v(_vm._s(item.Civilite))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-nom",
      staticStyle: {
        "white-space": "normal"
      },
      style: (_vm.getSizeColName()),
      attrs: {
        "title": item.FullName
      }
    }, [(item.Photo != '') ? _c('img', {
      staticClass: "photo mr-2",
      attrs: {
        "alt": "Photo",
        "src": item.Photo
      },
      on: {
        "click": function($event) {
          _vm.openSalarie(item.Id, item.Civilite + ' ' + item.FullName)
        }
      }
    }) : _c('div', {
      staticClass: "photo mr-2",
      style: ({
        background: _vm.randomColor(item.Id)
      }),
      on: {
        "click": function($event) {
          _vm.openSalarie(item.Id, item.Civilite + ' ' + item.FullName)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(item.Initiales) + "\n                                    ")]), _vm._v(" "), _c('a', {
      attrs: {
        "data-testid": "salaries-employee-name-link"
      },
      on: {
        "click": function($event) {
          _vm.openSalarie(item.Id, item.Civilite + ' ' + item.FullName)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(item.FullName) + "\n                                    ")]), _vm._v(" "), (item.EstSupprimable && _vm.userCanDeleteSalarie) ? _c('span', {
      staticClass: "delete"
    }, [_c('button', {
      staticClass: "btn-mini",
      attrs: {
        "type": "button",
        "title": "Supprimer"
      },
      on: {
        "click": function($event) {
          _vm.deleteItem(item.Id, item.FullName)
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-trash-alt"
    })])]) : _vm._e(), _vm._v(" "), (item.EnAlerte) ? _c('span', {
      staticClass: "alert",
      attrs: {
        "title": "Le numéro de sécurité sociale est invalide"
      }
    }, [_c('span', {
      staticClass: "fas fa-exclamation"
    })]) : _vm._e()]), _vm._v(" "), (_vm.NomNaissanceVisible) ? _c('div', {
      staticClass: "td cln-naissance",
      attrs: {
        "title": item.NomNaissance
      }
    }, [_vm._v("\n                                    " + _vm._s(item.NomNaissance) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.DateNaissanceVisible) ? _c('div', {
      staticClass: "td cln-date-naissance text-center",
      attrs: {
        "title": _vm._f("moment")(item.DateNaissance, 'DD/MM/YY')
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("moment")(item.DateNaissance, "DD/MM/YY")) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.QualificationVisible) ? _c('div', {
      staticClass: "td cln-qualification",
      attrs: {
        "title": item.Qualification
      }
    }, [_vm._v("\n                                    " + _vm._s(item.Qualification) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.LibelleEmploiVisible) ? _c('div', {
      staticClass: "td cln-emploi text-center",
      attrs: {
        "title": item.LibelleEmploi
      }
    }, [_vm._v("\n                                    " + _vm._s(item.LibelleEmploi) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.DateEntreeVisible) ? _c('div', {
      staticClass: "td cln-entree text-center"
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("moment")(item.DateEntree, "DD/MM/YY")) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.DateDebutContratVisible) ? _c('div', {
      staticClass: "td cln-debut text-center"
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("moment")(item.DateDebutContrat, "DD/MM/YY")) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.DateDepartVisible) ? _c('div', {
      staticClass: "td cln-sortie text-center"
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("moment")(item.DateDepart, "DD/MM/YY")) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.DateFinPeriodeEssaiVisible) ? _c('div', {
      staticClass: "td cln-essai text-center",
      attrs: {
        "title": _vm._f("moment")(item.DateFinPeriodeEssai, 'DD/MM/YY')
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("moment")(item.DateFinPeriodeEssai, "DD/MM/YY")) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.DateFinContratVisible) ? _c('div', {
      staticClass: "td cln-fin text-center"
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("moment")(item.DateFinContrat, "DD/MM/YY")) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.DateFinPrevisionnelleCddVisible) ? _c('div', {
      staticClass: "td cln-previsionnelle text-center",
      attrs: {
        "title": _vm._f("moment")(item.DateFinPrevisionnelleCdd, 'DD/MM/YY')
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("moment")(item.DateFinPrevisionnelleCdd, "DD/MM/YY")) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.TypeContratVisible) ? _c('div', {
      staticClass: "td cln-type text-center",
      attrs: {
        "title": item.TypeContrat
      }
    }, [_vm._v("\n                                    " + _vm._s(item.TypeContrat) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.RegimeVisible) ? _c('div', {
      staticClass: "td cln-regime text-center",
      attrs: {
        "title": item.Regime
      }
    }, [_vm._v("\n                                    " + _vm._s(item.Regime) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.BulletinParMailVisible) ? _c('div', {
      staticClass: "td cln-bulletin text-center"
    }, [(item.BulletinParMail) ? _c('span', {
      staticClass: "fas fa-check"
    }) : _c('span', {
      staticClass: "fas fa-times"
    })]) : _vm._e(), _vm._v(" "), (_vm.NatureContratVisible) ? _c('div', {
      staticClass: "td cln-nature text-center",
      attrs: {
        "title": item.NatureContrat
      }
    }, [_vm._v("\n                                    " + _vm._s(item.NatureContrat) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.ServiceVisible) ? _c('div', {
      staticClass: "td cln-service text-center",
      attrs: {
        "title": item.Service
      }
    }, [_vm._v("\n                                    " + _vm._s(item.Service) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.RemunerationVisible) ? _c('div', {
      staticClass: "td cln-remuneration text-center",
      attrs: {
        "title": item.Remuneration
      }
    }, [_vm._v("\n                                    " + _vm._s(item.Remuneration) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.CongesVisible) ? _c('div', {
      staticClass: "td cln-conges text-center",
      attrs: {
        "title": item.Conges
      }
    }, [_vm._v("\n                                    " + _vm._s(item.Conges) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.ConventionCollectiveVisible) ? _c('div', {
      staticClass: "td cln-convention",
      attrs: {
        "title": item.ConventionCollective
      }
    }, [_vm._v("\n                                    " + _vm._s(item.ConventionCollective) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.TempsTravailVisible) ? _c('div', {
      staticClass: "td cln-temps text-center",
      attrs: {
        "title": item.TempsTravail
      }
    }, [_vm._v("\n                                    " + _vm._s(item.TempsTravail) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.MutuelleVisible) ? _c('div', {
      staticClass: "td cln-mutuelle",
      attrs: {
        "title": item.Mutuelle
      }
    }, [_vm._v("\n                                    " + _vm._s(item.Mutuelle) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.ModeReglementVisible) ? _c('div', {
      staticClass: "td cln-mode text-center",
      attrs: {
        "title": item.ModeReglement
      }
    }, [_vm._v("\n                                    " + _vm._s(item.ModeReglement) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.ResponsableHierarchiqueVisible) ? _c('div', {
      staticClass: "td cln-responsable",
      attrs: {
        "title": item.ResponsableHierarchique
      }
    }, [_vm._v("\n                                    " + _vm._s(item.ResponsableHierarchique) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.DateEntreeProfessionVisible) ? _c('div', {
      staticClass: "td cln-profession text-center",
      attrs: {
        "title": _vm._f("moment")(item.DateEntreeProfession, 'DD/MM/YY')
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("moment")(item.DateEntreeProfession, "DD/MM/YY")) + "\n                                ")]) : _vm._e()])
  })], 2)]) : _vm._e()]) : (_vm.modeTuilles && _vm.salariesFiltred.length > 0) ? _c('div', {
    staticClass: "card-mode"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.salariesFiltred), function(item) {
    return _c('div', {
      staticClass: "col col-12 col-sm-6 col-md-6 col-lg-4 col-xl-2"
    }, [_c('div', {
      staticClass: "inp-box",
      class: _vm.isFinContrat(item) ? 'grey-card' : '',
      attrs: {
        "data-testid": "salaries-grid-card",
        "data-contrat-termine": _vm.isFinContrat(item) ? 'true' : 'false'
      },
      on: {
        "click": function($event) {
          _vm.openSalarie(item.Id, item.Civilite + ' ' + item.FullName)
        }
      }
    }, [_c('div', {
      staticClass: "left"
    }, [(item.Photo != '') ? _c('img', {
      staticClass: "photo mr-3",
      attrs: {
        "alt": "Photo",
        "src": item.Photo
      }
    }) : _c('div', {
      staticClass: "photo mr-3",
      style: ({
        background: _vm.randomColor(item.Id)
      })
    }, [_vm._v("\n                                        " + _vm._s(item.Initiales) + "\n                                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('ul', {
      staticClass: "list"
    }, [_c('li', {
      staticClass: "name mb-1"
    }, [_vm._v("\n                                            " + _vm._s(item.Civilite) + " "), _c('span', {
      staticClass: "fullname"
    }, [_vm._v(_vm._s(item.FullName))])]), _vm._v(" "), _c('li', {
      staticClass: "phone"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("N° Tél :")]), _vm._v(_vm._s(_vm.formatPhoneNumber(item.Telephone)) + "\n                                        ")]), _vm._v(" "), _c('li', {
      staticClass: "mail"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("Email :")]), _vm._v(_vm._s(item.EMail))])])])])])
  }))]) : _c('div', {
    staticClass: "empty-area"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('span', {
    staticClass: "fas fa-info-circle fa-3x mb-2",
    staticStyle: {
      "color": "#95a5a6"
    }
  }), _vm._v(" "), _c('div', [_vm._v("Aucun salarié trouvé ")]), _vm._v(" "), (_vm.filterName.length == 0 && _vm.filtreTypeContrat == 'EnCours') ? _c('div', [_vm._v("\n                            dans les\n                            "), _c('strong', [_vm._v("\n                                Contrats en cours\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.filterName.length == 0 && _vm.filtreTypeContrat == 'Expires') ? _c('div', [_vm._v("\n                            dans les\n                            "), _c('strong', [_vm._v("\n                                Contrats expirés de l'exercice\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.filterName.length == 0 && _vm.filtreTypeContrat == 'ActifExercice') ? _c('div', [_vm._v("\n                            dans les\n                            "), _c('strong', [_vm._v("\n                                Contrats actifs de l'exercice\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.filterName.length == 0 && _vm.filtreTypeContrat == 'HorsExercice') ? _c('div', [_vm._v("\n                            dans les\n                            "), _c('strong', [_vm._v("\n                                Contrats hors exercice\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.filterName.length == 0 && _vm.filtreTypeContrat == 'Tous') ? _c('div', [_vm._v("\n                            dans\n                            "), _c('strong', [_vm._v("\n                                Tous les contrats\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.filterName.length > 0) ? _c('div', [_vm._v("\n                            pour la recherche :\n                            "), _c('strong', [_vm._v(_vm._s(_vm.filterName))])]) : _vm._e()])])])]) : _c('loader'), _vm._v(" "), _c('modal-filter-liste-salaries', {
    ref: "refModalFilterListeSalaries",
    on: {
      "changeSize": _vm.changeSize
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2384f31a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salaries/listeSalaries.vue.html
// module id = 3jhD
// module chunks = 2